<script lang="ts" setup>
const model = defineModel<Date>({ required: true })
const timeMessage = useTimeAgoDk(model)
</script>

<template>
  <span>Runden varer indtil {{ timeMessage }}</span>
  <span class="text-zinc-500">
    (<CurrentRoundDate :datetime="model" />)
  </span>
</template>
